/** Title block shared by every page. */

import { el } from "../lib/dom";
import type { Child } from "../lib/dom";

export interface PageHeaderOptions {
  readonly title: string;
  readonly subtitle?: string;
  readonly actions?: readonly Child[];
}

export function pageHeader(options: PageHeaderOptions): HTMLElement {
  return el("div", {
    className: "page-header",
    children: [
      el("div", {
        className: "page-header__text",
        children: [
          el("h1", { className: "page-header__title", text: options.title }),
          options.subtitle === undefined
            ? null
            : el("p", { className: "page-header__subtitle", text: options.subtitle }),
        ],
      }),
      options.actions === undefined || options.actions.length === 0
        ? null
        : el("div", { className: "page-header__actions", children: options.actions }),
    ],
  });
}
